(() => {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  const trapFocus = (container) => {
    const focusable = qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return () => {};
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', onKey);
    first.focus();
    return () => container.removeEventListener('keydown', onKey);
  };

  const setupDrawer = ({drawer, overlay, openers, closer}) => {
    if (!drawer || !overlay || !openers.length || !closer) return;
    let releaseFocus = () => {};
    let lastOpener = null;
    const open = (opener) => {
      lastOpener = opener;
      drawer.classList.add('is-open');
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
      drawer.setAttribute('aria-hidden', 'false');
      opener?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      releaseFocus = trapFocus(drawer);
    };
    const close = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(o => o.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('is-locked');
      releaseFocus();
      window.setTimeout(() => { overlay.hidden = true; }, 300);
      lastOpener?.focus();
    };
    openers.forEach(opener => opener.addEventListener('click', () => open(opener)));
    closer.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    drawer._veloraOpen = open;
    drawer._veloraClose = close;
  };

  document.addEventListener('DOMContentLoaded', () => {
    setupDrawer({
      drawer: qs('#MenuDrawer'),
      overlay: qs('[data-menu-overlay]'),
      openers: qsa('[data-menu-open]'),
      closer: qs('[data-menu-close]')
    });

    setupDrawer({
      drawer: qs('#CartDrawer'),
      overlay: qs('[data-drawer-overlay]'),
      openers: qsa('[data-cart-open]'),
      closer: qs('[data-cart-close]')
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
      qsa('.reveal-on-scroll').forEach(el => observer.observe(el));
    } else qsa('.reveal-on-scroll').forEach(el => el.classList.add('is-visible'));

    qsa('.accordion').forEach(details => {
      details.addEventListener('toggle', () => {
        const summary = qs('summary', details);
        summary?.setAttribute('aria-expanded', String(details.open));
      });
    });

    qsa('[data-facets-toggle]').forEach(button => {
      button.addEventListener('click', () => button.closest('.facets')?.classList.toggle('is-open'));
    });
  });

  window.Velora = window.Velora || {};
  window.Velora.qs = qs;
  window.Velora.qsa = qsa;
})();
